import { PiSignOutDuotone } from "react-icons/pi";

export default function MasterUserMenu({ user, brand, onLogout }) {
  return (
    <div className="border-t border-slate-800 p-3 lg:px-5 lg:py-4 shrink-0">
      <div className="hidden lg:block mb-3">
        <div className="text-sm font-semibold text-slate-100 truncate" data-testid="master-user-name">{user.name}</div>
        <div className="font-mono text-[10px] tracking-widest uppercase" style={{ color: brand.primary_color }}>{user.role?.replace(/_/g, " ")}</div>
      </div>
      <button
        data-testid="master-logout-btn"
        onClick={onLogout}
        className="flex items-center gap-2 text-xs text-slate-400 hover:text-red-400 transition-colors"
      >
        <PiSignOutDuotone className="text-base" />
        <span className="hidden lg:inline">Sign out</span>
      </button>
      {brand.footer_text && (
        <div className="hidden lg:block mt-3 text-[10px] text-slate-500" data-testid="master-footer-text">
          {brand.footer_text}
        </div>
      )}
    </div>
  );
}
